export default {
  __html: `<g fill="#currentColor" fill-rule="evenodd">
                <path d="M19.609 15H10.39C9.623 15 9 14.552 9 14s.623-1 1.391-1h9.218c.768 0 1.391.448 1.391 1s-.623 1-1.391 1"/>
                <path d="M23.997 24H7.004C4.796 24 3 22.304 3 20.22v-7.96c0-.696.598-1.26 1.335-1.26s1.334.564 1.334 1.26v7.96c0 .694.599 1.26 1.335 1.26h16.993c.735 0 1.334-.566 1.334-1.26v-7.96c0-.696.598-1.26 1.335-1.26S28 11.564 28 12.26v7.96c0 2.084-1.796 3.78-4.003 3.78M2.74 7.503h25.52V3.746c0-.689-.614-1.249-1.37-1.249H4.11c-.756 0-1.37.56-1.37 1.249v3.757zM29.63 10H1.37C.613 10 0 9.44 0 8.75V3.747C0 1.68 1.844 0 4.11 0h22.78C29.158 0 31 1.68 31 3.746V8.75C31 9.44 30.387 10 29.63 10z"/>
            </g>`
}



// WEBPACK FOOTER //
// ./src/app/elements/Icon/packageDelivery.js